import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/categoryCourseRelation/importer/categoryCourseRelationImporterActions'

export default importerReducers(actions)
